import { themeObject } from 'lib';

export const styles = {
    emptyStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    emptyHeadingContainer: {
        mt: 4,
    },
    emptyHeadingText: {
        fontFamily: 'Raleway',
        fontSize: '26px',
        fontWeight: 500,
        lineHeight: '30.52px',
        color: themeObject.palette.primary[700],
    },
    emptySubHeadingContainer: {
        mt: 2,
    },
    emptySubHeadingText: {
        fontFamily: 'Red Hat Text',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[700],
        textAlign: 'center',
    },
};
